import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TripService } from 'app/services/trip.service';
import { WaybillService } from 'app/services/waybill.service';
import * as Chart from 'chart.js'
import { environment } from 'environments/environment';
import Echo from 'laravel-echo';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {
  to: Date;
  trip: any;
  header = [];
  values = [];
  barchart = [];
  year_start: any;
  year_end: any;
  trip_history: any;
  // expanded: boolean;
  trip_movement: any;
  origin: any;
  destination: any;
  status: any;
  ind_trip_details: any;

  readonly rootUrlhost = environment.rootUrlhost;
  way_bills: any[];
  // waybillservice: any;
  datasource = new MatTableDataSource<any>();
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  searchValue: any;
  displayedWayBills = ['index', 'waybill_date', 'waybill_no', 'sender_name', 'receiver_name', 'item_name', 'quantity', 'loaded_pkg', 'trip_name', 'check_point', 'tracking_position_status', 'narration'];
  echo: Echo;
  socket: any;
  show_full: boolean;
  detailed: any;
  not_detailed: any[];
  loaded_total: number = 0;
  quantity_total: number = 0;

  way_bill_number: any;
  mobile_number: string;
  searchNumberValue: any;
  searchMobNumberValue: any
  years: any;
  selected_year: any;

  constructor(private tripService: TripService, private waybillservice: WaybillService, private pipe: DatePipe) { }

  ngOnInit() {
    this.to = new Date();
    // const to = this.pipe.transform(this.to, 'yyyy-MM-dd');
    this.selected_year = parseInt(this.pipe.transform(this.to, 'yyyy'));
    this.searchValue = '';
    this.way_bill_number = '';
    this.mobile_number = '';
    this.getTripStatistics();
    this.getLast50Trips();

    // this.socket.on('laravel_database_chat', data => {
    //   console.log(data);
    // });

    // this.echo = new Echo({
    //   broadcaster: 'socket.io',
    //   host: 'http://localhost:6001'
    // });

    // this.echo.connector.socket.on('connect', function () {
    //   console.log('CONNECTED');
    // });

    // this.echo.connector.socket.on('reconnecting', function () {
    //   console.log('CONNECTING');
    // });

    // this.echo.connector.socket.on('disconnect', function () {
    //   console.log('DISCONNECTED');
    // });

    // this.echo.channel('laravel_database_chat')
    //   .listen('.test', (data) => {
    //     console.log(data);
    //   });
  }

  /**
   * search waybill by waybill_number
   * 
   * @param details 
   */
  searchByNumber(details) {
    console.log(details);
    this.way_bills = [];
    if (details) {
      this.waybillservice.searchWayBill(details).subscribe((res: any) => {
        console.log(res);
        this.way_bills = res.data;
        this.showCreation(res.data);

        // this.datasource = new MatTableDataSource(res.data);
        // this.datasource.sort = this.sort;
      });
    }else{
      this.setEmpty();
    }
    // this.datasource = new MatTableDataSource(this.way_bills);
    // this.datasource.sort = this.sort;
  }

  /**
   * search waybill by waybill_number
   * 
   * @param id 
   */
  searchByWaybillNumber(id) {
    console.log(id);
    this.way_bills = [];
    if (id) {
      this.waybillservice.searchWayBillNumber(id).subscribe((res: any) => {
        console.log(res);
        this.way_bills = res.data;
        this.showCreation(res.data);

        // this.datasource = new MatTableDataSource(res.data);
        // this.datasource.sort = this.sort;
      });
    }else{
      this.setEmpty();
    }
    // this.datasource = new MatTableDataSource(this.way_bills);
    // this.datasource.sort = this.sort;
  }

  /**
* search waybill by waybill_number
* 
* @param details 
*/
  searchByMobNumber(details) {
    console.log(details);
    this.way_bills = [];
    if (details) {
      this.waybillservice.searchMobile(details).subscribe((res: any) => {
        console.log(res);
        this.way_bills = res.data;
        this.showCreation(res.data);

        // this.datasource = new MatTableDataSource(res.data);
        // this.datasource.sort = this.sort;
      });
    }else{
      this.setEmpty();
    }
    // this.datasource = new MatTableDataSource(this.way_bills);
    // this.datasource.sort = this.sort;
  }

  showCreation(details) {
    let waybills = new Array;
    let id = 0;
    let o_id = 0;
    let item_name = '';
    let quantity = 0;
    let loaded_pkg = 0;
    let consignment_id = 0;
    let o_consignment_id = 0;

    details.forEach(element => {
      id = element.id;
      consignment_id = element.consignment_id;

      if (id != o_id) {
        waybills.push(element)
        o_id = element.id;
        o_consignment_id = element.consignment_id;

        item_name = element.item_name
        quantity = element.quantity
        loaded_pkg = element.loaded_pkg
      } else {
        item_name += ', ' + element.item_name;
        loaded_pkg += element.loaded_pkg;

        if (consignment_id != o_consignment_id) {
          quantity += element.quantity;
          o_consignment_id = element.consignment_id;
        } 
        // else {
        //   quantity = element.quantity;
        // }

        let new_value = { 'id': id, 'waybill_date': element.waybill_date, 'waybill_no': element.waybill_no, 'sender_name': element.sender_name, 'receiver_code': element.receiver_code, 'receiver_name': element.receiver_name, 'item_name': item_name, 'quantity': quantity, 'loaded_pkg': loaded_pkg, 'trip_name': element.trip_name, 'check_point': element.check_point, 'tracking_position_status': element.tracking_position_status, 'narration': element.narration }

        waybills[waybills.length - 1] = new_value;
      }
    });

    this.detailed = details;
    this.not_detailed = waybills;

    this.datasource = new MatTableDataSource(waybills);
    this.loaded_total = this.datasource.data.map(t => Number(t.loaded_pkg)).reduce((acc, value) => acc + value, 0);
    this.quantity_total = this.datasource.data.map(t => Number(t.quantity)).reduce((acc, value) => acc + value, 0);

    console.log(this.loaded_total);
    console.log(this.quantity_total);

    let data = [];
    if (this.show_full) {
      data = this.detailed
    } else {
      data = this.not_detailed
    }

    this.datasource = new MatTableDataSource(data);
    this.datasource.sort = this.sort;
  }

  setEmpty(){
    console.log('setEmpty');
    
    this.datasource = new MatTableDataSource([]);
    this.loaded_total = 0;
    this.quantity_total = 0;
  }

  showControl() {
    let data = [];
    if (this.show_full) {
      this.show_full = false;
      data = this.not_detailed
    } else {
      this.show_full = true;
      data = this.detailed
    }

    this.datasource = new MatTableDataSource(data);
    this.datasource.sort = this.sort;
  }

  getQuantityTotal1() {
    return this.datasource.data.map(t => Number(t.quantity)).reduce((acc, value) => acc + value, 0);
  }

  getLoadedTotal1() {
    return this.datasource.data.map(t => Number(t.loaded_pkg)).reduce((acc, value) => acc + value, 0);
  }


  getLast50Trips() {
    this.tripService.getLast50Trips().subscribe((res: any) => {
      console.log(res);
      this.trip_history = res.data;
      if (this.trip_history.length > 0) {
        // this.expanded = true;
        const first_trip_id = this.trip_history[0].id;
        // const first_trip_id = this.trip_history[0].trip_no;
        this.getTripDetails(first_trip_id);
      }
    });
  }

  /**
   * 
   * @param trip_id 
   */
  getTripDetails(trip_id) {
    // this.expanded = true;
    delete this.trip_movement;
    delete this.origin;
    delete this.destination;
    delete this.status;
    delete this.ind_trip_details;

    this.tripService.getTripTrackDetails(trip_id).subscribe((res: any) => {
      console.log(res);
      // this.trip_movement = res.data;
      // this.origin = res.origin;
      // this.destination = res.destination;
      // this.status = res.status;
      // console.log(this.status);
      // this.ind_trip_details = this.trip_movement[this.trip_movement.length - 1];
      // console.log(this.ind_trip_details);

      this.ind_trip_details = res.trip_data;
      this.trip_movement = res.trip_movement;

      this.trip_movement.forEach(element => {
        console.log(element);
        console.log(element.check_point.length);

        element.width = (element.check_point.length > (element.tracking_position_status ? element.tracking_position_status.length : 0)) ? element.check_point.length + '%' : element.tracking_position_status.length + '%';
      });
      console.log(this.trip_movement);
    });
  }

  /**
   * Trip statitics
   * @param date till date
   */
  public getTripStatistics() {
    console.log(this.selected_year);
    // var selected_date = this.pipe.transform(this.selected_year, 'yyyy-MM-dd');

    console.log(typeof(this.selected_year));


    var selected_date1 = new Date(this.selected_year.toString());
    var selected_date = this.pipe.transform(selected_date1, 'yyyy-MM-dd');

    console.log(selected_date);

    this.tripService.getTripStatistics(selected_date).subscribe((res: any) => {
      console.log(res);
      this.trip = res.trip;
      this.year_start = res.year_start;
      this.year_end = new Date(res.year_end);
      this.year_end.setDate(this.year_end.getDate()-1);
      this.years = res.years;

      this.drawTripChart('line');
    });
  }

  /**
   * Draw the chart 
   * @param type Chart type
   */
  public drawTripChart(type) {
    this.header = [];
    this.values = [];

    // Header and content setting
    this.trip.forEach(x => {
      this.header.push(x.name);
      this.values.push(x.total);
    });

    this.barchart = new Chart('trip-statitis', {
      type: type,
      data: {
        labels: this.header,
        datasets: [
          {
            data: this.values,
            borderColor: '#3cba9f',
            backgroundColor: [
              "#1989a8",
              "#fca103",
              "#195aa8",
              "#0d7507",
              "#00ffa6",
              "#0091ff",
              "#1d43a3",
              "#8c6cad",
              "#ac6cad",
              "#38222e",
              "#db7b91",
              "#ab9698"
            ],
            fill: false
          }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        aspectRatio: 1,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            display: true,
            ticks: {
              beginAtZero: true
            }
          }],
          yAxes: [{
            display: true,
            ticks: {
              beginAtZero: true
            }
          }],
        }
      }
    });
  }
}
